"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "Write down a negative or unhelpful thought that you\u2019ve had recently. They may start with \u201CI am\u2026\u201D \u201CI\u2019m not\u2026\u201D or \u201CI can\u2019t\u201D. It may also be an unhelpful or negative thought about a situation e.g. \u201CThey ignored my suggestion\u201D. You can use one of the thoughts that you have previously identified in Retraining Thinking.",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'If "__content__" was true what does this say about me?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Then answer, if "__content__" was true what does this say about me?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Now if "__content__" was true what does this say about me?',
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: 'Finally, if I thought "__content__" was true what does this say about me?',
  placeholder: "",
  type: "multirow",
  aggregated: true,
  optional: false
}, {
  prompt: "",
  extraText: "You may have uncovered your root belief by this point. You\u2018ll know when you\u2019ve reached your root belief when the statement begins with \u201CI\u2026\u201D and it seems absolute e.g. \u201CI\u2019m never good enough\u201D. When you reach your root belief you will most likely feel anxious, sad, angry, or other uncomfortable emotions.\nRemember it\u2019s normal to feel this way when you\u2019ve uncovered a painful belief system that has been unhelpful to you. Uncovering your root belief helps you to become more aware of when these beliefs may be controlling parts of your life.\nMy root belief is:",
  placeholder: "",
  type: "multirow",
  aggregated: true,
  optional: false
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 5),
    rootThought: answers[5]
  };
}

;